import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core'
import { environment } from 'src/environments/environment'
import { OwlOptions } from 'ngx-owl-carousel-o'
import { subCatOptions } from 'src/app/modules/services/models/services.constant'
import { serviceDetails, SubCategory } from 'src/app/modules/services/models/service-template.model'
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'
import { ActivatedRoute } from '@angular/router'
import { ServicesService } from 'src/app/modules/services/services/services.service'
import { BranchCategory, serviceFilter } from 'src/app/modules/services/models/services.model'
import { MatRadioChange } from '@angular/material/radio'
import { MatDialog } from '@angular/material/dialog'
import { Package } from '../../models/package.model'

@Component({
	selector: 'app-add-package-services',
	templateUrl: './add-package-services.component.html',
	styleUrls: ['./add-package-services.component.scss'],
})
export class AddPackageServicesComponent implements OnInit {
	@ViewChildren('checkboxElements') checkboxElements!: QueryList<ElementRef>
	@Output() emittedServices = new EventEmitter()
	@Input() packageData!: Package
	@Input() branchId!: number
	@Output() addServiceMode = new EventEmitter()
	@Output() isEditMode = new EventEmitter()
	@Output() viewMode = new EventEmitter()

	breadCrumbRout: any

	attachmentPath = environment.attachmentPath
	categories: BranchCategory[] = []
	services: any = []
	subCatOptions: OwlOptions = {
		...subCatOptions,
		rtl: this.translate.currentLang == 'ar' ? true : false,
	}

	subCategories: any[] = []
	selectedSubCategory!: number
	selectedCategory!: BranchCategory
	allServicesChecked: boolean = false
	servicesObject: serviceDetails[] = []
	subscription: Subscription = new Subscription()
	queryParamObj: any = {}
	serviceFilter: serviceFilter = {
		paging: { pageNumber: 1, pageSize: 10 },
		categoryIds: [],
	}
	subCategory: any = []
	totalCount = 0

	constructor(
		public translate: TranslateService,
		private ServicesServ: ServicesService,
		private activeRout: ActivatedRoute,
		private cd: ChangeDetectorRef,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.subscription.add(
			this.activeRout.queryParams.subscribe((res) => {
				this.branchId = res['branchId']
			})
		)

		this.getCategories()
		this.servicesObject = this.packageData?.packageServices
	}

	getCategories() {
		let body = {
			...this.serviceFilter,
			branchId: this.branchId,
		}
		this.subscription.add(
			this.ServicesServ.getCategories(body).subscribe((res: any) => {
				this.categories = res?.result?.items
				this.subCategories = this.categories[0].subCategories
				this.selectedCategory = this.categories[0]
				this.selectedSubCategory = this.selectedCategory?.subCategories[0].id
				this.initSubOwl()
				this.getServices()
			})
		)
	}
	initSubOwl() {
		this.cd.detectChanges()
		this.subCategories.forEach((sub: any, i: number) => {
			sub.width = document.getElementById('slide-' + i)?.offsetWidth
			this.cd.detectChanges()
		})
		this.subCategories[0].width =
			document.getElementById('slide-0')?.offsetWidth

		this.subCatOptions = { ...this.subCatOptions }
	}

	getServices() {
		let body = {
			...this.serviceFilter,
			branchId: this.branchId,
			categoryIds: [this.selectedCategory.id],
			subCategoryIds: [this.selectedSubCategory],
		}

		this.subscription.add(
			this.ServicesServ.getServices(body).subscribe((res: any) => {
				this.services = res?.result?.items
				this.totalCount = res?.result?.totalCount
			})
		)
	}

	getSearchFilter(event: any) {
		this.serviceFilter.searchText = event
		this.serviceFilter.categoryIds = []
		this.serviceFilter.subCategoryIds = []
		this.serviceFilter.paging.pageNumber = 1
		this.getServices()
	}
	onCategoryChanged(event: MatRadioChange) {
		this.selectedCategory = event.value
		this.subCategories = event.value?.subCategories
		this.initSubOwl()
		this.selectedSubCategory = event.value?.subCategories[0]?.id
		this.serviceFilter.paging.pageNumber = 1
		this.getServices()
	}
	onSubCategoryClicked(subCategory: SubCategory) {
		this.selectedSubCategory = subCategory?.id
		this.serviceFilter.paging.pageNumber = 1

		this.getServices()
	}

	checkAllServices(isChecked: boolean) {
		this.allServicesChecked = isChecked
		if (isChecked) {
			this.servicesObject = [...this.services]
		} else {
			this.servicesObject = []
		}
	}
	checkService(isChecked: boolean, service: serviceDetails) {
		if (isChecked) {
			this.servicesObject.push(service)
		} else {
			let serviceIndex = this.servicesObject.findIndex(
				(s) => s.id === service.id
			)
			this.servicesObject.splice(serviceIndex, 1)
		}
	}

	isChecked(id: number) {
		return this.servicesObject.find((res) => res.id == id) ? true : false
	}
	onCancelled() {
		this.servicesObject = []
		this.allServicesChecked = false
		this.checkboxElements.forEach((item: any) => {
			item.checked = false
		})
		this.addServiceMode.emit(false)
	}

	onSaved() {
		this.emittedServices.emit({
			value: this.servicesObject,
			isValid: !!this.servicesObject.length,
			index: 2,
		})
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
